import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { styled } from '@mui/material'
import UserPopover from 'vendors/components/appBar/UserPopover'
import ThingerLogo from 'vendors/components/icons/ThingerLogo'
import Box from '@mui/material/Box'

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar)

export default function ButtonAppBar() {
  return (
    <>
      <AppBar position="fixed">
        <Toolbar sx={{ color: 'common.white' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ height: 44, width: 120 }}>
              <ThingerLogo />
            </Box>
          </Box>
          <UserPopover />
        </Toolbar>
      </AppBar>
      <Offset />
    </>
  )
}
